import { COMMON_AMOUNT_ISSUE, MAX_AMOUNT_ISSUE, MIN_AMOUNT_ISSUE, MULTIPLE_AMOUNT_ISSUE } from 'apps/auth/constants/Constants';
import { resolveArguments } from 'apps/auth/helpers/utils';

type ErrorMessages = {
    minValidError?: string;
    limitReached?: string;
    viewDetails?: string;
};

type ErrorCode = typeof COMMON_AMOUNT_ISSUE | typeof MIN_AMOUNT_ISSUE | typeof MAX_AMOUNT_ISSUE | typeof MULTIPLE_AMOUNT_ISSUE;

type ValidationResult = {
    error: {
        code: ErrorCode;
        body?: string;
    };
    errorMessage?: string;
    isError: boolean;
    isShowToViewDetails: boolean;
};

export class GaSendingAmountValidationService {
    private errorMessages: ErrorMessages;

    constructor(errorMessages: ErrorMessages) {
        this.errorMessages = errorMessages;
    }

    getValidationError(
        value: number | string | null | undefined,
        min: number | string | null | undefined,
        max: number | string | null | undefined,
        multiple: number | string | null | undefined,
        isFrom: boolean,
        pocketBalance: number | string | null | undefined,
        currencyCode: string,
    ): ValidationResult {
        let errorCode: ErrorCode = COMMON_AMOUNT_ISSUE;
        let errorMessage: string | undefined;
        let isError = false;
        let isShowToViewDetails = false;

        const numericValue = Number(value);
        const numericMin = Number(min);
        const numericMax = Number(max);
        const numericMultiple = Number(multiple);
        const numericPocketBalance = Number(pocketBalance);

        if (numericMin && numericValue !== 0 && numericValue < numericMin) {
            errorCode = MIN_AMOUNT_ISSUE;
            errorMessage = resolveArguments(this.errorMessages.minValidError, [min ?? undefined, currencyCode]);
            isError = true;
        } else if (numericMax && numericValue > numericMax) {
            errorCode = MAX_AMOUNT_ISSUE;
            isError = true;
            isShowToViewDetails = true;
            errorMessage = this.errorMessages.limitReached;
        } else if ((numericMultiple && numericValue % numericMultiple !== 0) || (isFrom && numericPocketBalance && numericValue > numericPocketBalance)) {
            errorCode = MULTIPLE_AMOUNT_ISSUE;
            isError = true;
            isShowToViewDetails = true;
            errorMessage = this.errorMessages.viewDetails;
        }

        return {
            error: {
                code: errorCode,
                body: errorMessage,
            },
            errorMessage,
            isError,
            isShowToViewDetails,
        };
    }
}
